import './Icon_Chevron_Down.css';
 import { ReactComponent as ChevronDownIcon } from './Icons_ChevronDown_Outline_Brand.svg';

function Icon_Chevron_Down() {
  return (
    <div className='icon-container-chevron-down'>
      <ChevronDownIcon className="chevron-down-svg" />
    </div>
  );
}
 
export default Icon_Chevron_Down;
 